module.exports = __webpack_public_path__ + "static/AL-f714a330ccdc7219bae4d4fda1f839a5.mp4";